import { Sector } from '@/domain/impact/impact.entity';
import {
  Category,
  ImpactCo2Answer,
  NonRecyclableWasteType,
  NonRecyclableWasteTypeValues,
  ValuesNonRecyclableWaste,
} from '@/domain/impact-co2/entities/question.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { ImportedRow } from '../convert-excel-to-impact-answers';
import { buildBaseAnswer } from './common/build-base-answer';
import {
  filterRowsByCategory,
  filterRowsBySectors,
} from './common/filter-rows-by-category';
import { ImportMappingError } from './common/import-mapping.error';

const CATEGORY: Category = 'NON_RECYCLABLE_WASTE';
const SECTORS: Sector[] = ['SITE'];

export function mapToNonRecyclableWasteAnswers(
  rows: ImportedRow[],
): ImpactCo2Answer<ValuesNonRecyclableWaste>[] {
  return rows
    .filter(filterRowsByCategory(CATEGORY))
    .filter(filterRowsBySectors(SECTORS))
    .map((row) => buildAnswer(row));
}

function buildAnswer(row: ImportedRow) {
  const nonRecyclableWasteType = mapToNonRecyclableWasteType(row);
  const nonRecyclableWasteQuantity = mapToNonRecyclableWasteQuantity(row);
  const baseAnswer = buildBaseAnswer(row, CATEGORY);
  const answer = {
    ...baseAnswer,
    values: {
      ...baseAnswer.values,
      nonRecyclableWasteType,
      nonRecyclableWasteQuantity,
    },
  };
  return answer;
}

function mapToNonRecyclableWasteType(row: ImportedRow): NonRecyclableWasteType {
  const tgsValue = row['Fairly Sub Category Description'];
  const result = validateValueInType<NonRecyclableWasteType>(
    tgsValue,
    NonRecyclableWasteTypeValues,
  );
  if (!result) {
    throw new ImportMappingError('nonRecyclableWasteType', tgsValue, row);
  }
  return result;
}

function mapToNonRecyclableWasteQuantity(row: ImportedRow): number {
  const tgsValue = row['Weight (kg)'];
  let result = parseFloat(tgsValue);
  if (isNaN(result)) {
    throw new ImportMappingError('nonRecyclableWasteQuantity', tgsValue, row);
  }
  result = result / 1000; // convert kg to tonnes
  return result;
}
